import injectSheet from 'react-jss';

import ControlTile from './component';
import styles from './styles';

export default injectSheet(styles)(ControlTile);
